import React from 'react';
import { useLocation } from 'react-router-dom';
import PrivateRoutes from "./PrivateRoutes";
import { IsLoggedIn } from "../utils/RolesChecker";
import Chatbot from '../views/Chatbot/Chatbot';
import PublicRoutes from './PublicRoutes';
import RelanceDevis from '../views/RelanceDevis/RelanceDevis';
import * as URL from "../config/UrlConstants";

const RELANCE_DEVIS_PREFIX = "/relance-devis/";

const Router = () => {
	const location = useLocation();
	const pathname = location?.pathname || window.location.pathname;

	// Pages accessibles avec ou sans connexion
	if (pathname.startsWith(RELANCE_DEVIS_PREFIX)) {
		return <RelanceDevis />;
	}
	if (pathname === URL.CHATBOT_VIEW_PATH) {
		return <Chatbot />;
	}

	// Utilisateur connecté → routes privées
	if (IsLoggedIn()) {
		return <PrivateRoutes />;
	}

	// Non connecté → page de connexion / mot de passe oublié, etc.
	return (
		<div className={"page-connection"}>
			<PublicRoutes />
		</div>
	);
};

export default Router;
